
    <div class="header-container">
        <div class="pin-icon" [ngStyle]="{'width':'10%'}">
            <i (click) = "closeDialog()" routerLink = "pinnedDialog" routerLinkActive = "active" [ngStyle]="{'cursor':'pointer'}" class="material-icons">push_pin</i>
        </div>
        <div class="header-left-container">
            <h2 mat-dialog-title>Previous Meeting History</h2>
        </div>
        <div class="header-right-container">
            <mat-form-field>
                <input type="text" matInput placeholder="search">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
        </div>
    </div>
    <mat-dialog-content class="main-container">
        <ng-scrollbar [ngStyle]="{'height':'600px'}" #scrollable pointerEventsMethod="scrollbar" [disabled]="disabled">
        <!-- <div [ngStyle]="{'height':'600px'}"> -->
            <cdk-accordion class="example-accordion"> 
                <cdk-accordion-item
                  #accordionItem="cdkAccordionItem">
                  <div class="example-accordion-item-header" (click)="accordionItem.toggle()">
                    <span class="example-accordion-item-description">
                        <mat-icon class="icon">{{accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
                    </span>
                    <div class="accordion-header-container">
                        <div class="accordion-header-left-container">
                            <h2 class="accordion-title">Project Status Meeting</h2>
                            <p>{{currentDate}}. at 2:00 PM for 60 minutes</p>
                        </div>
                    </div>
                  </div>
                  <div>
                    <ul class="un-order-list-container">
                        <li class="list-item">Lakshmi Kala M</li>
                        <li class="list-item">Shivakumar M</li>
                        <li class="list-item">Chandrasekar K</li>
                        <li class="list-item">3 More..</li>
                    </ul>
                </div>
                  <div>
                      <mat-list>
                        <mat-list-item>
                            <div class="list-item-container">
                                <div>
                                    <h2 class = "agenda-name">Agenda - 1:</h2>
                                </div>
                                <div>
                                    <h3>Project status meeting</h3>
                                    <p>Description</p>
                                </div>      
                            </div>
                        </mat-list-item>
                      </mat-list>
                  </div>
                  <div
                    class="example-accordion-item-body"
                    role="region"
                    [style.display]="accordionItem.expanded ? '' : 'none'">
                        <div class="accordion-container">
                            <div class="accordion-left-container">
                                <div>
                                    <h3>Note</h3>
                                </div>
                                <div>
                                </div>
                            </div>
                            <div class="accordion-right-container">
                                <div>
                                    <h3>Task</h3>
                                </div>
                                <div>
                                </div>
                            </div>
                        </div>
                  </div>
                </cdk-accordion-item>
                <mat-divider class="divider"></mat-divider>
                <cdk-accordion-item
                  #accordionItem="cdkAccordionItem">
                  <div class="example-accordion-item-header" (click)="accordionItem.toggle()">
                    <span class="example-accordion-item-description">
                        <mat-icon class="icon">{{accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
                    </span>
                    <div class="accordion-header-container">
                        <div class="accordion-header-left-container">
                            <h2 class="accordion-title">Project Status Meeting</h2>
                            <p>{{currentDate}}. at 2:00 PM for 60 minutes</p>
                        </div>
                    </div>
                  </div>
                  <div>
                    <ul class="un-order-list-container">
                        <li class="list-item">Lakshmi Kala M</li>
                        <li class="list-item">Shivakumar M</li>
                        <li class="list-item">Chandrasekar K</li>
                        <li class="list-item">3 More..</li>
                    </ul>
                </div>
                  <div>
                      <mat-list>
                        <mat-list-item>
                            <div class="list-item-container">
                                <div>
                                    <h2 class = "agenda-name">Agenda - 1:</h2>
                                </div>
                                <div>
                                    <h3>Project status meeting</h3>
                                    <p>Description</p>
                                </div>      
                            </div>
                        </mat-list-item>
                      </mat-list>
                  </div>
                  <div
                    class="example-accordion-item-body"
                    role="region"
                    [style.display]="accordionItem.expanded ? '' : 'none'">
                        <div class="accordion-container">
                            <div class="accordion-left-container">
                                <div>
                                    <h3>Note</h3>
                                </div>
                                <div>
                                </div>
                            </div>
                            <div class="accordion-right-container">
                                <div>
                                    <h3>Task</h3>
                                </div>
                                <div>
                                </div>
                            </div>
                        </div>
                  </div>
                </cdk-accordion-item>
                <mat-divider class="divider"></mat-divider>
                <cdk-accordion-item
                  #accordionItem="cdkAccordionItem">
                  <div class="example-accordion-item-header" (click)="accordionItem.toggle()">
                    <span class="example-accordion-item-description">
                        <mat-icon class="icon">{{accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
                    </span>
                    <div class="accordion-header-container">
                        <div class="accordion-header-left-container">
                            <h2 class="accordion-title">Project Status Meeting</h2>
                            <p>{{currentDate}}. at 2:00 PM for 60 minutes</p>
                        </div>
                    </div>
                  </div>
                  <div>
                    <ul class="un-order-list-container">
                        <li class="list-item">Lakshmi Kala M</li>
                        <li class="list-item">Shivakumar M</li>
                        <li class="list-item">Chandrasekar K</li>
                        <li class="list-item">3 More..</li>
                    </ul>
                </div>
                  <div>
                      <mat-list>
                        <mat-list-item>
                            <div class="list-item-container">
                                <div>
                                    <h2 class = "agenda-name">Agenda - 1:</h2>
                                </div>
                                <div>
                                    <h3>Project status meeting</h3>
                                    <p>Description</p>
                                </div>      
                            </div>
                        </mat-list-item>
                      </mat-list>
                  </div>
                  <div
                    class="example-accordion-item-body"
                    role="region"
                    [style.display]="accordionItem.expanded ? '' : 'none'">
                        <div class="accordion-container">
                            <div class="accordion-left-container">
                                <div>
                                    <h3>Note</h3>
                                </div>
                                <div>
                                </div>
                            </div>
                            <div class="accordion-right-container">
                                <div>
                                    <h3>Task</h3>
                                </div>
                                <div>
                                </div>
                            </div>
                        </div>
                  </div>
                </cdk-accordion-item>
                <mat-divider class="divider"></mat-divider>
            </cdk-accordion>              
        <!-- </div> -->
        </ng-scrollbar>
    </mat-dialog-content>
<!-- </ng-scrollbar> -->